;(() => {
    const posts = document.querySelectorAll('.fb-embed')

    const resizePost = post => {
        const rawHeight = parseInt(post.dataset.height) 
        const rawWidth = parseInt(post.dataset.width)
        const aspect = rawWidth / rawHeight
        const width = parseInt(post.offsetWidth)
        const height = width / aspect + 50
        post.style.width = width + 'px'
        post.style.height = height + 'px'
    }

    const resizeAllPosts = () => {
        posts.forEach(post => {
            resizePost(post)
        })
    }

    resizeAllPosts()

    window.addEventListener('resize', resizeAllPosts)
})()
